import React, { useEffect, useRef } from 'react';

/** Embeds the TradingView real-time ticker tape for top crypto pairs. */
const TVTicker: React.FC = () => {
  const ref = useRef<HTMLDivElement>(null);
  const loaded = useRef(false);

  useEffect(() => {
    if (!ref.current || loaded.current) return;
    loaded.current = true;

    const script = document.createElement('script');
    script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js';
    script.async = true;
    script.innerHTML = JSON.stringify({
      symbols: [
        { proName: 'BINANCE:BTCUSDT',  title: 'BTC/USDT' },
        { proName: 'BINANCE:ETHUSDT',  title: 'ETH/USDT' },
        { proName: 'BINANCE:SOLUSDT',  title: 'SOL/USDT' },
        { proName: 'BINANCE:BNBUSDT',  title: 'BNB/USDT' },
        { proName: 'BINANCE:XRPUSDT',  title: 'XRP/USDT' },
        { proName: 'BINANCE:ADAUSDT',  title: 'ADA/USDT' },
        { proName: 'BINANCE:DOGEUSDT', title: 'DOGE/USDT' },
        { proName: 'BINANCE:DOTUSDT',  title: 'DOT/USDT' },
      ],
      showSymbolLogo: false,
      isTransparent: true,
      displayMode: 'compact',
      colorTheme: 'dark',
      locale: 'en',
    });
    ref.current.appendChild(script);
  }, []);

  return (
    <div className="tradingview-widget-container overflow-hidden rounded-xl border border-gray-800/40 mb-4" ref={ref}>
      <div className="tradingview-widget-container__widget" />
    </div>
  );
};

export default TVTicker;
